import { DashboardSpecMigrator } from '../dashboard-schema-migrator';
import { QueryDefinition } from '../../model/query';
import { DashboardV0 } from '../../dashboard-spec-versions';

/**
 * Migrates dashboard spec to version 0
 */
// Setting previous spec to `any` because we no longer have the old schema defined
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const V0Migrator: DashboardSpecMigrator<any, DashboardV0['spec']> = {
  version: '0',
  migrate: (spec) => {
    // Convert template variables from object to array
    if (spec.variables && !Array.isArray(spec.variables)) {
      spec.variables = [];
    }

    return spec as DashboardV0['spec'];
  },
  migratePanel: (panel) => {
    const { plugin, queries, ...theRestOfTheSpec } = panel.spec;

    if (queries !== undefined) {
      // Rename data query plugin kind to 'DataQuery'
      queries.map((queryPlugin: QueryDefinition) => {
        if ((queryPlugin.kind as string) !== 'DataQuery') {
          queryPlugin.kind = 'DataQuery';
        }
      });
      return panel;
    }

    // Move queries out of the panel plugin spec
    let pluginQueries;
    if (plugin?.spec?.queries !== undefined || plugin?.spec?.query !== undefined) {
      const newQueries: Record<string, QueryDefinition[] | undefined> = {
        TimeSeriesChart: plugin.spec.queries,
        StatChart: [plugin.spec.query],
        GaugeChart: [plugin.spec.query],
        Markdown: undefined,
      };
      pluginQueries = newQueries[plugin.kind];
    }

    if (plugin?.spec?.queries) {
      delete plugin.spec.queries;
    } else if (plugin?.spec?.query) {
      delete plugin.spec.query;
    }

    const newPanel: DashboardV0['spec']['panels'][string] = {
      kind: 'Panel',
      spec: {
        ...theRestOfTheSpec,
        plugin,
        queries: pluginQueries,
      },
    };

    return newPanel;
  },
};
